module.exports = __webpack_public_path__ + "img/widget-novo-r.59de1fa1.png";